<template>
  <hm-content>
    <div>
      <div class="flex flex item-center mb20">
        <div class="mr10 title">选择配色方案</div>
        <div class="flex-1 scheme flex flex-wrap">
          <div
            class="flex pointer flex-between scheme-item"
            v-for="(v, i) in scheme"
            :class="[{ active: activeTab === i }, v.className]"
            @click="activeTab = i"
            :key="i"
          >
            <div
              class="lightColor"
              :style="{ backgroundColor: v.lightColor }"
            ></div>
            <div
              class="baseColor"
              :style="{ backgroundColor: v.baseColor }"
            ></div>
            <div
              class="backgroundColor"
              :style="{ backgroundColor: v.backgroundColor }"
            ></div>
            <div class="color" :style="{ backgroundColor: v.color }"></div>
          </div>
        </div>
      </div>
      <div class="case flex">
        <div class="title mr10">当前风格示例</div>
        <div class="flex-1">
          <img class="case-img" :src="scheme[activeTab].img" alt="" />
        </div>
      </div>
      <div class="btn-wrapper p20 flex flex-center">
        <el-button type="primary" size="small" @click="saveStyle"
          >保存</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      activeTab: 0,
      scheme: [
        {
          className: "crimson-theme",
          baseColor: "#F72B2B",
          lightColor: "#FFD7D7",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps45e21a691ce68f8c-c5b8-4bc7-88f1-611ef25955cc.png"
        },
        {
          className: "pink-theme",
          baseColor: "#F6306F",
          lightColor: "#FFD7E4",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps41ca65b2dba1c92c-544e-44c1-b0d2-8843c69a167d.png"
        },
        {
          className: "purple-theme",
          baseColor: "#A32BF7",
          lightColor: "#EFD7FF",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps668232bb5dc5edf8-fde5-435a-87ce-84a2e3d6e95e.png"
        },
        {
          className: "blue-theme",
          baseColor: "#2BA3F7",
          lightColor: "#D4EDFF",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/psc3141d63832095b2-f987-44bb-9489-3110b7474f5c.png"
        },
        {
          className: "orange-theme",
          baseColor: "#FF5500",
          lightColor: "#FFE0CA",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/psbb93758cbd824ec8-257d-4694-a3f1-a38a402f0a5b.png"
        },
        {
          className: "black-theme",
          baseColor: "#2E2E2E",
          lightColor: "#979BA4",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps57a9ffb38a9e5c2a-b437-4914-87bc-3779e0c95dcf.png"
        },
        {
          className: "light-yellow-theme",
          baseColor: "#FFB400",
          lightColor: "#FFE29D",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps599eb29ebb5b0547-b2dc-498d-ad92-8749d4d4032d.png"
        },
        {
          className: "dark-green-theme",
          baseColor: "#489F31",
          lightColor: "#6BC04E",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/pscab334e6c61bf3f6-ab20-4d10-8b6e-25c3ae9e986f.png"
        },
        {
          className: "ke-theme",
          baseColor: "#24AF98",
          lightColor: "#D5F8F2",
          backgroundColor: "#fff",
          color: "#2B2B2B",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/%E9%A3%8E%E6%A0%BC8.png"
        }
      ]
    };
  },
  computed: mapGetters(["storeStyle"]),
  watch: {
    storeStyle(val) {
      if (!val.img) {
        this.activeTab = 0;
      } else {
        this.activeTab = this.scheme.findIndex(
          v => v.className === val.className
        );
      }
    }
  },
  created() {
    this.$store.dispatch("queryStoreStyle");
  },
  mounted() {},
  methods: {
    saveStyle() {
      const params = this.scheme[this.activeTab];
      this.$store.dispatch("setStoreStyle", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  color: #222;
  font-size: 14px;
  font-weight: bold;
}
.case-img {
  width: calc(100% - 130px);
}
.scheme-item {
  background: #f5f5f5;
  padding: 7px 10px;
  border-radius: 3px;
  margin-right: 10px;
  width: 156px;
  margin-bottom: 10px;
  border: 1px solid transparent;
  &.active {
    border: 1px solid #e50065;
  }
}
@mixin content {
  div {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
}
.crimson-theme {
  @include content;
}
.pink-theme {
  @include content;
}
.purple-theme {
  @include content;
}
.blue-theme {
  @include content;
}
.orange-theme {
  @include content;
}
.black-theme {
  @include content;
}
.crimson-theme {
  @include content;
}
.dark-green-theme {
  @include content;
}

.light-yellow-theme {
  @include content;
}

.ke-theme {
  @include content;
}
</style>
